/*
Copyright 2021 Carnegie Mellon University. All Rights Reserved. 
 Released under a MIT (SEI)-style license. See LICENSE.md in the project root for license information.
*/

/**
 * Alloy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type HealthStatus = 'Unhealthy' | 'Degraded' | 'Healthy';

export const HealthStatus = {
    Unhealthy: 'Unhealthy' as HealthStatus,
    Degraded: 'Degraded' as HealthStatus,
    Healthy: 'Healthy' as HealthStatus
};

